import { useEffect, useState } from 'react';
import type { User } from '../lib/api';

export function TelegramAvatar({ user, className = 'avatar' }: { user?: User | null; className?: string }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [user?.photo_url]);
  return <span className={`${className} telegram-avatar`} aria-label={user ? `${user.first_name}的頭像` : '訪客'}>
    {user?.photo_url && !failed
      ? <img src={user.photo_url} alt="" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
      : user?.first_name?.slice(0, 1) || '會'}
  </span>;
}
